import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import IntegrationMarketModal from "../Modal/IntegrationMarketModal";
import Field from "../../../../Pages/Settings/Content/Components/Field";

import { RequestSetConfig } from "../../../../store/actions/integrationsActions";

import "./styles.scss";

const IcapProxySettings = ({ show, setShow, dataTmp = 0, setActiveInt }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [server, setServer] = useState("");
  const [port, setPort] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [company, setCompany] = useState("");
  const [short, setShort] = useState("");
  const [cirtemail, setCirtEmail] = useState("");

  const [serverError, setServerError] = useState(false);
  const [portError, setPortError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [shortError, setShortError] = useState(false);
  const [cirtError, setCirtError] = useState(false);

  const getConfig = useSelector((state) => state.integrations.getConfig);

  const closePopupHandler = () => {
    history.push("/integration-market");
    setShow(false);
    setActiveInt("");
  };

  const addConfig = () => {
    if (isValidInput()) {
      const config = {
        server: server,
        port: port,
        username: username,
        password: password,
        company: company,
        short: short,
        cirtemail: cirtemail,
        tls: 1,
        enabled: 0,
      };
      const configString = JSON.stringify(config);
      const data = { appname: "icapweb", config: configString };

      dispatch(RequestSetConfig(data));
      closePopupHandler();
    } else {
      console.log("error");
    }
  };

  const isValidInput = () => {
    if (server && port && username && password && company && short && cirtemail) {
      return true;
    } else {
      if (!server) {
        setServerError(true);
      } else {
        setServerError(false);
      }
      if (!port) {
        setPortError(true);
      } else {
        setPortError(false);
      }
      if (!username) {
        setUsernameError(true);
      } else {
        setUsernameError(false);
      }
      if (!password) {
        setPasswordError(true);
      } else {
        setPasswordError(false);
      }
      if (!company) {
        setCompanyError(true);
      } else {
        setCompanyError(false);
      }
      if (!short) {
        setShortError(true);
      } else {
        setShortError(false);
      }
      if (!cirtemail) {
        setCirtError(true);
      } else {
        setCirtError(false);
      }
      return false;
    }
  };

  useEffect(() => {
    setServer(getConfig?.config?.server);
    setPort(getConfig?.config?.port);
    setUsername(getConfig?.config?.username);
    setPassword(getConfig?.config?.password);
    setCompany(getConfig?.config?.company);
    setShort(getConfig?.config?.short);
    setCirtEmail(getConfig?.config?.cirtemail);
  }, [getConfig]);

  return show ? (
    <IntegrationMarketModal title="Icap Proxy Email Notification" onClose={closePopupHandler}>
      <div className="icapproxy-settings">
        <div className="flex flex-align-items-center">
          <div className="flex-column m-r-10">
            <Field
              label="Server"
              width="180px"
              value={server}
              onChange={(e) => setServer(e.target.value)}
              placeholder="Enter server"
            />
            {serverError && <div className="error-message">Please enter a valid value.</div>}
          </div>
          <div className="flex-column m-r-10">
            <Field
              label="Port"
              width="180px"
              value={port}
              onChange={(e) => setPort(e.target.value)}
              placeholder="Enter port"
            />
            {portError && <div className="error-message">Please enter a valid value.</div>}
          </div>
          <div className="flex-column">
            <Field
              label="Username"
              width="180px"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
            />
            {usernameError && <div className="error-message">Please enter a valid value.</div>}
          </div>
        </div>

        <div className="flex flex-align-items-center m-t-20">
          <div className="flex-column m-r-10">
            <Field
              label="Password"
              width="180px"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
            {passwordError && <div className="error-message">Please enter a valid value.</div>}
          </div>
          <div className="flex-column m-r-10">
            <Field
              label="Company"
              width="180px"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              placeholder="Enter company"
            />
            {companyError && <div className="error-message">Please enter a valid value.</div>}
          </div>
          <div className="flex-column">
            <Field
              label="Short"
              width="180px"
              value={short}
              onChange={(e) => setShort(e.target.value)}
              placeholder="Enter short"
            />
            {shortError && <div className="error-message">Please enter a valid value.</div>}
          </div>
        </div>

        <div className="flex flex-align-items-center m-t-20">
          <div className="flex-column">
            <Field
              label="Cirt Email"
              width="180px"
              value={cirtemail}
              onChange={(e) => setCirtEmail(e.target.value)}
              placeholder="Enter cirt email"
            />
            {cirtError && <div className="error-message">Please enter a valid value.</div>}
          </div>
        </div>
      </div>

      <div className="integration-market-modal__action">
        <button onClick={addConfig} className="primary-button">
          Update
        </button>
      </div>
    </IntegrationMarketModal>
  ) : null;
};

export default IcapProxySettings;
